import React from 'react';
import FieldInput from '../../../../_common/components/FieldInput';
import ButtonAction from '../../../../_common/components/ButtonAction';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import {floatValue} from '../../../../../../utils/format';
import styles from '../styles.module.scss';

const RowWithholdingTax = ({
                             fieldsSet,
                             removeRow
                           }) => {
  return (
    <div className={styles.withholdingTaxRowContainer}>
      <FieldInput fieldId={fieldsSet.price} onChange={floatValue}/>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'error'}
        onClick={removeRow}
        label={<img src={toAbsoluteUrl('/media/common/Delete_red.svg')} alt="delete"/>}
        customClassnames={'mr-4 ml-auto'}
        avoidDoubleClick={false}
      />
    </div>
  );
};

export default RowWithholdingTax;